export default {
  getNBA: '/nba/getNBA',
  getDepartmentNBA: '/nba/getDepartmentNBA',
  updateNBA: '/nba/updateNBA',
  updateDepartmentNBA: '/nba/updateDepartmentNBA'
}
